import React, { type ReactNode } from "react";
import { cn } from "@ndd/ui";
import { MedicareHatch } from "./funnel-bar";

function LegendItem({ swatch, children }: { swatch: ReactNode; children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-[6px]">
      {swatch}
      {children}
    </span>
  );
}

function Swatch({ className }: { className: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-block h-[10px] w-[10px] rounded-[2px]", className)}
    />
  );
}

export function FunnelLegend({ medicareCapped }: { medicareCapped: number }) {
  return (
    <div className="flex flex-wrap items-center gap-[18px] border-t border-border px-[18px] py-3 text-body-sm text-muted-strong">
      <LegendItem swatch={<Swatch className="bg-success-soft" />}>
        Meets or above target
      </LegendItem>
      <LegendItem swatch={<Swatch className="bg-warning-soft" />}>Watch</LegendItem>
      <LegendItem swatch={<Swatch className="bg-danger-soft" />}>Below</LegendItem>
      <LegendItem
        swatch={
          <MedicareHatch
            patternId="medicare-hatch-legend"
            label="Hatched segment"
            className="h-[10px] w-[10px] rounded-[2px]"
          />
        }
      >
        Medicare · 3-session cap ({medicareCapped} patients)
      </LegendItem>
    </div>
  );
}
